import React from 'react'
import ProductLanding from '../../../components/product-landing'

const Component = () => {
  return <ProductLanding productName="nulinga" />
}

export default Component
